import script from "./AuctionMonitor.vue?vue&type=script&setup=true&lang=js"
export * from "./AuctionMonitor.vue?vue&type=script&setup=true&lang=js"

import "./AuctionMonitor.vue?vue&type=style&index=0&id=2ab59f8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab59f8c"]])

export default __exports__